import fs from 'fs';
import * as http from "http";
import * as https from "https";
import express from "express";
import expressws from "express-ws";

//SSL
// const options = {
//     cert: fs.readFileSync("resources/test-certifs/certif.crt"),
//     key: fs.readFileSync("resources/test-certifs/certif.key")
// };
//
// fs.writeFileSync('logs.txt', "");

const app = express();
app.use(express.urlencoded({ extended: false }));
app.use(express.json({ limit: '50mb' }));
//app.enable('trust proxy');

//middleware to debug problems
app.use((req, res, next) => {
    let log = 'Time:' + Date.now() + " => ";
    log += req.protocol + " request on : " + req.originalUrl + '\n';
    log += JSON.stringify(req.headers);

    fs.appendFile('logs.txt', log + '\n', (err) => { });
    next()
})

//http 8080
const httpServer = http.createServer(app).listen(22002, () => {
    console.info('Listening HTTP 8080');
});


// import fs from 'fs';
// import dotenv from "dotenv";
// import { SecureWebSocketServer } from "./server/secure-websocket-server";
// import { HttpsServer } from "./server/https-server";
// import { JSONHelper } from "./common/json-helper";
// import { UserRegisterService as UserRegisterService } from "./services/app/authentication/user-register-service";
// import { BorneRegisterService as BornerRegisterService } from "./services/app/borne-register-service";
// import { ConnectionService } from "./services/app/authentication/connection-service";
// import { EditProfileService } from "./services/app/edit-profile-service";
// import { BadgeRegisterService } from './services/app/badge-register-service';
// import { RefreshTokenService } from './services/app/authentication/refresh-token-service';
// import { LoadDatasService } from './services/app/authentication/load-datas-service';
// import { CalendarEditService } from './services/prices/calendar-price-service';
// import { ChargeProgramAddService } from './services/app/programs/charge-program-add-service';
// import { ChargeHistoryService } from './services/app/charge/charge-history-service';
// import { SaveUserSettingsService } from './services/app/save-settings-service';
// import { AppWebSocketService } from './services/app/app-websocket-services';
// import { ChargeProgramDeleteService } from './services/app/programs/charge-program-delete-service';
// import { ChargeProgramUpdateService } from './services/app/programs/charge-program-update-service';
// import { StartChargeService } from './services/app/charge/start-charge-service';
// import { StopChargeService } from './services/app/charge/stop-charge-service';
// import { HistoryPDFService } from './services/app/charge/charge-history-pdf-service';
// import { MailManager } from './common/mail-helper';
// import { PriceAddService } from './services/prices/price-calculation-add-service';
// import { PriceUpdateService } from './services/prices/price-calculation-update-service';
// import { PriceDeleteService } from './services/prices/price-calculation-delete-service';
// import { LoggerHelper } from './common/logger-helper';
// import { TestService } from './services/app/test-service';
// import tls from 'tls';
//
// class ServiceList {
//     service_register?: string;
//     service_connection?: string;
//     service_refresh_session?: string;
//     service_load_datas?: string;
//
//     service_borne_register?: string;
//     service_edit_profile?: string;
//     service_badge_register?: string;
//     service_history?: string;
//     service_history_pdf?: string;
//
//
//     service_add_price?: string;
//     service_update_price?: string;
//     service_delete_price?: string;
//     service_temporal_price_day?: string;
//
//     service_program_add?: string;
//     service_program_delete?: string;
//     service_program_update?: string;
//
//     service_save_settings?: string;
//     service_start_charge?: string;
//     service_stop_charge?: string;
//     service_app_main_ws?: string;
//
//
//     static isValid(o: any): o is ServiceList {
//         return true;
//     }
// }
//
// export class Logger {
//
// }
//
// export class WebSocketMessagesIDs {
//     connected?: string;
//     error?: string;
//     msg_current_charge?: string;
//     start_charge?: string;
//
//     static isValid(o: any): o is WebSocketMessagesIDs {
//         return true;
//     }
// }
// fs.writeFileSync('logs.txt', "");
// LoggerHelper.info('start server');
//
// export const webSocketsMessageIds = JSONHelper.getObjectFromJSON<WebSocketMessagesIDs>(fs.readFileSync('resources/config/ws_messages.json', 'utf8'), WebSocketMessagesIDs.isValid)!;
//
//
// dotenv.config();
//
// const options = {
//     key: fs.readFileSync(process.env.CRT_KEY),
//     cert: fs.readFileSync(process.env.CRT_FILE)
// };
//
// try {
//     tls.createSecureContext(options);
//     LoggerHelper.debug("Certif valid");
//
// } catch (error) {
//     LoggerHelper.debug("Certif not valid", error);
// }
//
//
// const httpsServer = new HttpsServer(options, process.env.SERVER_HTTP_PORT, process.env.SERVER_HTTPS_PORT);
//
// let rawData = fs.readFileSync('resources/config/services_names.json', 'utf8');
// const servicesList = JSONHelper.getObjectFromJSON<ServiceList>(rawData, ServiceList.isValid)!;
//
// httpsServer.addService(new UserRegisterService(servicesList.service_register!));
// httpsServer.addService(new ConnectionService(servicesList.service_connection!));
// httpsServer.addService(new RefreshTokenService(servicesList.service_refresh_session!));
// httpsServer.addService(new LoadDatasService(servicesList.service_load_datas!));
//
// httpsServer.addService(new BornerRegisterService(servicesList.service_borne_register!));
// httpsServer.addService(new EditProfileService(servicesList.service_edit_profile!));
// httpsServer.addService(new BadgeRegisterService(servicesList.service_badge_register!));
//
// httpsServer.addService(new PriceAddService(servicesList.service_add_price!));
// httpsServer.addService(new PriceUpdateService(servicesList.service_update_price!));
// httpsServer.addService(new PriceDeleteService(servicesList.service_delete_price!));
//
// httpsServer.addService(new CalendarEditService(servicesList.service_temporal_price_day!));
//
//
// httpsServer.addService(new ChargeProgramAddService(servicesList.service_program_add!));
// httpsServer.addService(new ChargeProgramDeleteService(servicesList.service_program_delete!));
// httpsServer.addService(new ChargeProgramUpdateService(servicesList.service_program_update!));
//
// httpsServer.addService(new ChargeHistoryService(servicesList.service_history!));
// httpsServer.addService(new SaveUserSettingsService(servicesList.service_save_settings!));
// httpsServer.addService(new HistoryPDFService(servicesList.service_history_pdf!));
//
// httpsServer.addService(new StartChargeService(servicesList.service_start_charge!));
// httpsServer.addService(new StopChargeService(servicesList.service_stop_charge!));
//
// httpsServer.addService(new TestService("test"));
//
// export const appWebSocket = new AppWebSocketService(servicesList.service_app_main_ws!);
//
// // if (process.env.WEBSOCKET_MODE != "none") {
// // const wsServer = new SecureWebSocketServer(httpsServer, process.env.WEBSOCKET_MODE!);
// // wsServer.addService(appWebSocket);
// // }
//
// MailManager.getInstance().check();
//
// LoggerHelper.info('server started');
// //FireBaseManager.sendNotificationToDevice(TEST_TOKEN, "test", "toto");
